import { render, staticRenderFns } from "./PublicationVideoItem.vue?vue&type=template&id=4b43e8a5&scoped=true&lang=pug&"
import script from "./PublicationVideoItem.vue?vue&type=script&lang=js&"
export * from "./PublicationVideoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b43e8a5",
  null
  
)

export default component.exports